import axios from 'axios';
import getAuthClient from 'Core_Helpers/getAuthClient';
import urlcat from 'urlcat';

type ApiResponse = {
  response: any;
  hasError: boolean;
  error: object;
  success: boolean;
};

export class ApiService {
  /** Creates a single instance of the class */
  private static _instance: ApiService = new ApiService();
  /** Documentation on abort controller usage: https://axios-http.com/docs/cancellation  */
  private static _abortController: AbortController = new AbortController();

  constructor() {
    // Make sure we don't create more than one instance of this service
    if (ApiService._instance) {
      return ApiService._instance;
    }
  }

  public get = async (url: string, params: object): Promise<ApiResponse> => {
    const authorizedApiClient = await getAuthClient();

    if (authorizedApiClient && url) {
      return await authorizedApiClient
        .get(urlcat(process.env.API_BASE_URL as string, url, params), { signal: ApiService._abortController.signal })
        .then(function (response) {
          return {
            response: response?.data,
            hasError: false,
            error: undefined,
            success: true,
          };
        })
        .catch(function (error) {
          if (!axios.isCancel(error)) {
            return {
              response: undefined,
              hasError: true,
              error: error?.data,
              success: false,
            };
          }
        });
    }
  };

  public post = async (url: string, params: object, requestBody: object): Promise<ApiResponse> => {
    const authorizedApiClient = await getAuthClient();

    if (authorizedApiClient && url) {
      return await authorizedApiClient
        .post(urlcat(process.env.API_BASE_URL as string, url, params), requestBody, {
          signal: ApiService._abortController.signal,
        })
        .then(function (response) {
          return {
            response: response?.data,
            hasError: false,
            error: undefined,
            success: true,
          };
        })
        .catch(function (error) {
          if (!axios.isCancel(error)) {
            return {
              response: undefined,
              hasError: true,
              error: error?.data,
              success: false,
            };
          }
        });
    }
  };

  public put = async (url: string, params: object, requestBody: object): Promise<ApiResponse> => {
    const authorizedApiClient = await getAuthClient();

    if (authorizedApiClient && url) {
      return await authorizedApiClient
        .put(urlcat(process.env.API_BASE_URL as string, url, params), requestBody, {
          signal: ApiService._abortController.signal,
        })
        .then(function (response) {
          return {
            response: response?.data,
            hasError: false,
            error: undefined,
            success: true,
          };
        })
        .catch(function (error) {
          if (!axios.isCancel(error)) {
            return {
              response: undefined,
              hasError: true,
              error: error?.data,
              success: false,
            };
          }
        });
    }
  };
}
